import React from 'react';
import { Banner } from './Banner';

type JobDetailsSwapBannerProps = {
  name: string;
};

export const JobDetailsSwapBanner = ({ name }: JobDetailsSwapBannerProps) => {
  return (
    <Banner
      bgColor="state.info.backing-1"
      iconColor="state.info.secondary"
      title={`Shift swap from ${name}`}
      subtitle="Subject to facility approval"
    />
  );
};
